import { usePageTitleSync } from "./usePageTitleSync";

export const PageTitleManager: React.FC = () => {
  usePageTitleSync();
  return null;
};
